export interface PiecesItem {
  label: string;
  href: string;
}

export interface ServicesItem {
  label: string;
  href: string;
}

export interface PiecesProps {
  title: string;
  description: string;
  items: PiecesItem[];
  highlight: string;
  imageAlt: string;
  imageSrc?: string;
}

export interface ServicesProps {
  title: string;
  description: string;
  items: ServicesItem[];
  highlight: string;
  imageAlt: string;
  imageSrc?: string;
}

// =========================================================
// IMAGES UNIQUES PAR SERVICE
// =========================================================
const IMG_DEFAULT_PIECES = "https://storage.readdy-site.link/project_files/8c50c74a-580c-4bdf-a3bb-6fdfe51fdb55/1bb6c9a1-0975-4352-a563-3d4f84311863_Intervention-rapide-scurisation.jpg?v=fdbca4ef0764616e1b4dcb778f1f8eb3";
const IMG_DEFAULT_SERVICES = "https://storage.readdy-site.link/project_files/8c50c74a-580c-4bdf-a3bb-6fdfe51fdb55/410e7c16-20a7-43e5-8433-f1e5bfa94a1b_reparation-fenetre.webp?v=8246b01b3ce32e096b4319ccc555e566";

const IMG_CREMONES = "https://readdy.ai/api/search-image?query=Close-up%20professional%20photo%20of%20a%20window%20locking%20mechanism%20called%20cremone%20being%20repaired%20by%20a%20technician%20hands%2C%20metal%20rods%20and%20gears%20visible%20inside%20a%20modern%20PVC%20window%20frame%2C%20clean%20workshop%20background%20with%20soft%20natural%20lighting%2C%20detailed%20technical%20photography%2C%20warm%20tones&width=800&height=600&seq=cremone-pieces-001&orientation=landscape";
const IMG_CREMONES_SERVICE = "https://readdy.ai/api/search-image?query=Professional%20technician%20replacing%20a%20window%20cremone%20locking%20mechanism%20inside%20a%20PVC%20window%2C%20wearing%20work%20gloves%2C%20using%20precision%20tools%2C%20bright%20interior%20of%20a%20residential%20home%20in%20France%2C%20natural%20daylight%2C%20clean%20professional%20repair%20scene%2C%20warm%20realistic%20tones&width=800&height=600&seq=cremone-service-001&orientation=landscape";

const IMG_POIGNEES = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20modern%20window%20handle%20being%20replaced%20on%20a%20white%20PVC%20window%20frame%2C%20technician%20hand%20installing%20a%20new%20metallic%20handle%2C%20clean%20and%20bright%20interior%20setting%2C%20professional%20repair%20photography%2C%20soft%20warm%20lighting%2C%20detailed%20product%20shot&width=800&height=600&seq=poignee-pieces-001&orientation=landscape";
const IMG_POIGNEES_SERVICE = "https://readdy.ai/api/search-image?query=Professional%20repairman%20installing%20a%20new%20window%20handle%20on%20a%20residential%20window%2C%20smiling%20at%20work%2C%20wearing%20branded%20uniform%2C%20bright%20French%20home%20interior%2C%20natural%20daylight%2C%20clean%20and%20professional%20scene%2C%20warm%20realistic%20photography&width=800&height=600&seq=poignee-service-001&orientation=landscape";

const IMG_GONDS = "https://storage.readdy-site.link/project_files/8c50c74a-580c-4bdf-a3bb-6fdfe51fdb55/697ebe72-c6d8-4373-a2d0-e385e88779b2_changement-paumelle-fenetre-1024x683-1.jpg?v=7d21e30618ff90878900ba8be7cb1a40";
const IMG_GONDS_SERVICE = "https://readdy.ai/api/search-image?query=Technician%20adjusting%20a%20large%20window%20hinge%20on%20a%20wooden%20frame%20in%20a%20classic%20French%20home%2C%20using%20professional%20tools%2C%20natural%20daylight%2C%20clean%20interior%20scene%2C%20professional%20repair%20photography%2C%20warm%20realistic%20tones&width=800&height=600&seq=gond-service-001&orientation=landscape";

const IMG_FERMEmAL = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20window%20rubber%20seal%20gasket%20being%20replaced%20by%20a%20technician%2C%20weatherstrip%20seal%20visible%2C%20clean%20PVC%20window%20frame%2C%20professional%20repair%20detail%20shot%2C%20bright%20interior%2C%20soft%20warm%20lighting%2C%20technical%20photography&width=800&height=600&seq=ferme-pieces-001&orientation=landscape";
const IMG_FERMEmAL_SERVICE = "https://readdy.ai/api/search-image?query=Technician%20repairing%20a%20window%20that%20closes%20poorly%2C%20adjusting%20the%20seal%20and%20locking%20points%20on%20a%20modern%20PVC%20window%2C%20French%20home%20interior%2C%20bright%20daylight%2C%20professional%20repair%20scene%2C%20clean%20and%20organized%20work%2C%20warm%20tones&width=800&height=600&seq=ferme-service-001&orientation=landscape";

const IMG_OSCILLO = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20tilt-and-turn%20window%20mechanism%20oscillo-battant%20being%20repaired%2C%20metal%20gears%20and%20rods%20visible%20inside%20the%20window%20frame%2C%20professional%20technician%20hands%2C%20detailed%20technical%20shot%2C%20clean%20workshop%20background%2C%20warm%20lighting&width=800&height=600&seq=oscillo-pieces-001&orientation=landscape";
const IMG_OSCILLO_SERVICE = "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3e2fe7d9885f0567bad4555622dccaef.jpeg";

const IMG_REGLAGE = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20technician%20adjusting%20a%20window%20hinge%20with%20an%20Allen%20key%20and%20screwdriver%2C%20precision%20adjustment%20of%20a%20modern%20PVC%20tilt-and-turn%20window%2C%20professional%20repair%20detail%2C%20bright%20interior%2C%20clean%20scene%2C%20warm%20lighting&width=800&height=600&seq=reglage-pieces-001&orientation=landscape";
const IMG_REGLAGE_SERVICE = "https://readdy.ai/api/search-image?query=Professional%20technician%20fine-tuning%20a%20window%20mechanism%20using%20a%20screwdriver%20and%20measuring%20tools%2C%20modern%20residential%20interior%20in%20France%2C%20bright%20natural%20daylight%2C%20clean%20organized%20work%20area%2C%20professional%20repair%20photography%2C%20warm%20realistic%20tones&width=800&height=600&seq=reglage-service-001&orientation=landscape";

const IMG_PVC = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20modern%20white%20PVC%20window%20profile%20with%20repair%20technician%20hands%20working%20on%20the%20internal%20mechanism%2C%20clean%20and%20bright%20residential%20setting%2C%20professional%20window%20repair%20scene%2C%20soft%20warm%20lighting%2C%20detailed%20technical%20photography&width=800&height=600&seq=pvc-pieces-001&orientation=landscape";
const IMG_PVC_SERVICE = "https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20a%20white%20PVC%20window%20in%20a%20modern%20French%20home%2C%20adjusting%20the%20locking%20mechanism%2C%20bright%20interior%20with%20natural%20daylight%2C%20clean%20and%20professional%20scene%2C%20warm%20realistic%20photography%2C%20residential%20setting&width=800&height=600&seq=pvc-service-001&orientation=landscape";

const IMG_ALU = "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/23eb1b95702aea6f23d59e6631489d05.jpeg";
const IMG_ALU_SERVICE = "https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20an%20aluminum%20window%20in%20a%20modern%20contemporary%20French%20home%2C%20sleek%20interior%20design%2C%20large%20aluminum%20window%20frame%2C%20natural%20daylight%2C%20clean%20professional%20repair%20scene%2C%20warm%20realistic%20photography&width=800&height=600&seq=alu-service-001&orientation=landscape";

const IMG_BOIS = "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20traditional%20wooden%20window%20frame%20with%20a%20technician%20repairing%20the%20ironmongery%20mechanism%2C%20classic%20French%20home%20style%2C%20warm%20wood%20texture%2C%20professional%20repair%20detail%2C%20soft%20natural%20lighting%2C%20detailed%20technical%20photography%2C%20warm%20tones&width=800&height=600&seq=bois-pieces-001&orientation=landscape";
const IMG_BOIS_SERVICE = "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a5678743fe9ccf4d4061d6534d54e38d.jpeg";

// =========================================================
// PIÈCES — DEFAULT (home, nos-prestations, tarifs, avis, contact, zones, qui-sommes-nous, mentions, politique)
// =========================================================
export const defaultPieces: PiecesProps = {
  title: "Toutes les pièces de votre fenêtre, réparées chez vous",
  description:
    "Quel que soit le type de fenêtre ou la marque de vos ferrures, notre technicien intervient avec un stock de pièces de rechange adaptées. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Pièce comprise, toutes marques (Ferco, GU, Roto, Maco, Siegenia).",
  imageAlt: "[PHOTO pièces de fenêtre : crémone, poignée, gonds]",
  imageSrc: IMG_DEFAULT_PIECES,
};

// =========================================================
// SERVICES — DEFAULT
// =========================================================
export const defaultServices: ServicesProps = {
  title: "Réparer plutôt que remplacer : nos interventions",
  description:
    "DF PRO Strasbourg répare toutes les pannes courantes de fenêtre, porte et baie vitrée. Intervention rapide, pièces comprises, toutes marques. Un diagnostic précis avant chaque travail.",
  items: [
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans.",
  imageAlt: "[PHOTO technicien réparant une fenêtre]",
  imageSrc: IMG_DEFAULT_SERVICES,
};

// =========================================================
// CRÉMONE
// =========================================================
export const cremonePieces: PiecesProps = {
  ...defaultPieces,
  title: "Toutes les pièces de crémone, remplacées sur place",
  description:
    "Crémone bloquée, crémaillère usée ou renvoi d'angle cassé ? Notre technicien arrive avec un stock de pièces adaptées aux principales marques de ferrures. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Pièce de crémone comprise, toutes marques (Ferco, GU, Roto, Maco, Siegenia).",
  imageAlt: "[PHOTO mécanisme de crémone et pièces de rechange]",
  imageSrc: IMG_CREMONES,
};

export const cremoneServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de crémone : nos interventions à domicile",
  description:
    "DF PRO Strasbourg remplace les crémones et mécanismes de verrouillage de toutes les marques. Intervention rapide, pièces comprises, diagnostic gratuit. Un travail précis pour restaurer la sécurité de votre fenêtre.",
  items: [
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur la crémone.",
  imageAlt: "[PHOTO technicien remplaçant une crémone]",
  imageSrc: IMG_CREMONES_SERVICE,
};

// =========================================================
// POIGNÉE
// =========================================================
export const poigneePieces: PiecesProps = {
  ...defaultPieces,
  title: "Toutes les pièces de poignée, remplacées chez vous",
  description:
    "Poignée qui tourne dans le vide, cassée ou bloquée ? Notre technicien arrive avec un stock de poignées adaptées aux principales marques. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Poignée comprise, toutes marques (Ferco, GU, Roto, Maco, Siegenia).",
  imageAlt: "[PHOTO poignée de fenêtre et carré d'entraînement]",
  imageSrc: IMG_POIGNEES,
};

export const poigneeServices: ServicesProps = {
  ...defaultServices,
  title: "Remplacement de poignée : nos interventions à domicile",
  description:
    "DF PRO Strasbourg remplace les poignées de fenêtre de toutes les marques. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre retrouve son fonctionnement en moins d'une heure.",
  items: [
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur la poignée.",
  imageAlt: "[PHOTO technicien installant une nouvelle poignée]",
  imageSrc: IMG_POIGNEES_SERVICE,
};

// =========================================================
// GOND / PAUMELLE
// =========================================================
export const gondPieces: PiecesProps = {
  ...defaultPieces,
  title: "Gonds et paumelles : pièces remplacées sur place",
  description:
    "Fenêtre qui s'affaisse, gond usé ou paumelle brisée ? Notre technicien arrive avec un stock de gonds et paumelles adaptés à toutes les marques. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Gonds et paumelles comprises, toutes marques et charges.",
  imageAlt: "[PHOTO gonds et paumelles de fenêtre]",
  imageSrc: IMG_GONDS,
};

export const gondServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de gonds et paumelles : nos interventions",
  description:
    "DF PRO Strasbourg remplace les gonds et paumelles de toutes les fenêtres. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre retrouve son alignement et sa solidité.",
  items: [
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur les gonds.",
  imageAlt: "[PHOTO technicien ajustant des gonds de fenêtre]",
  imageSrc: IMG_GONDS_SERVICE,
};

// =========================================================
// FENÊTRE FERME MAL
// =========================================================
export const fermeMalPieces: PiecesProps = {
  ...defaultPieces,
  title: "Pièces d'étanchéité : joints et serrage remplacés sur place",
  description:
    "Fenêtre qui laisse passer l'air, joints usés ou serrage insuffisant ? Notre technicien arrive avec un stock de joints et pièces d'étanchéité adaptés. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Joints et pièces d'étanchéité comprises, toutes marques.",
  imageAlt: "[PHOTO joints d'étanchéité et serrage de fenêtre]",
  imageSrc: IMG_FERMEmAL,
};

export const fermeMalServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de fenêtre qui ferme mal : nos interventions",
  description:
    "DF PRO Strasbourg répare les fenêtres qui ferment mal, qui laissent passer l'air ou l'eau. Intervention rapide, pièces comprises, diagnostic gratuit. Vous retrouvez confort et isolation.",
  items: [
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur l'étanchéité.",
  imageAlt: "[PHOTO technicien réparant une fenêtre qui ferme mal]",
  imageSrc: IMG_FERMEmAL_SERVICE,
};

// =========================================================
// OSCILLO-BATTANT BLOQUÉE
// =========================================================
export const oscilloBloqueePieces: PiecesProps = {
  ...defaultPieces,
  title: "Mécanisme oscillo-battant : pièces remplacées sur place",
  description:
    "Fenêtre bloquée en position inclinée, mécanisme déréglé ou anti-fausse manœuvre défectueux ? Notre technicien arrive avec un stock de pièces adaptées. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
  ],
  highlight: "Mécanisme oscillo-battant compris, toutes marques (GU, Roto, Maco, Siegenia).",
  imageAlt: "[PHOTO mécanisme oscillo-battant et pièces internes]",
  imageSrc: IMG_OSCILLO,
};

export const oscilloBloqueeServices: ServicesProps = {
  ...defaultServices,
  title: "Déblocage oscillo-battant : nos interventions à domicile",
  description:
    "DF PRO Strasbourg débloque les fenêtres oscillo-battant bloquées en position inclinée ou fermée. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre retrouve ses deux modes d'ouverture.",
  items: [
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur le mécanisme.",
  imageAlt: "[PHOTO technicien débloquant une fenêtre oscillo-battant]",
  imageSrc: IMG_OSCILLO_SERVICE,
};

// =========================================================
// RÉGLAGE OSCILLO-BATTANT
// =========================================================
export const reglagePieces: PiecesProps = {
  ...defaultPieces,
  title: "Réglage de mécanisme : pièces et outils pour un ajustement parfait",
  description:
    "Fenêtre oscillo-battant qui frotte, ferme mal ou déraille ? Notre technicien arrive avec les outils et pièces nécessaires pour un réglage précis. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
  ],
  highlight: "Pièces de réglage comprises, toutes marques et configurations.",
  imageAlt: "[PHOTO outils de réglage et mécanisme oscillo-battant]",
  imageSrc: IMG_REGLAGE,
};

export const reglageServices: ServicesProps = {
  ...defaultServices,
  title: "Réglage d'oscillo-battant : nos interventions à domicile",
  description:
    "DF PRO Strasbourg règle les fenêtres oscillo-battant qui frotte, ferment mal ou déraille. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre retrouve un mouvement fluide.",
  items: [
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
    { label: "Réparation de fenêtre qui ferme mal", href: "/fenetre-ferme-mal" },
    { label: "Remplacement de gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Fenêtre PVC, Alu et Bois", href: "/fenetre-pvc" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur le réglage.",
  imageAlt: "[PHOTO technicien réglant une fenêtre oscillo-battant]",
  imageSrc: IMG_REGLAGE_SERVICE,
};

// =========================================================
// PVC
// =========================================================
export const pvcPieces: PiecesProps = {
  ...defaultPieces,
  title: "Pièces pour fenêtre PVC : remplacement sur place",
  description:
    "Fenêtre PVC qui ferme mal, bloquée ou mécanisme usé ? Notre technicien arrive avec un stock de pièces adaptées aux fenêtres PVC de toutes les marques. Pas besoin de commander en ligne ni d'attendre des semaines.",
  items: [
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Pièces PVC comprises, toutes marques (Ferco, GU, Roto, Maco, Siegenia).",
  imageAlt: "[PHOTO pièces de fenêtre PVC et mécanisme interne]",
  imageSrc: IMG_PVC,
};

export const pvcServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de fenêtre PVC : nos interventions à domicile",
  description:
    "DF PRO Strasbourg répare toutes les pannes de fenêtres PVC : mécanisme, serrage, étanchéité. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre PVC retrouve ses performances.",
  items: [
    { label: "Fenêtre PVC", href: "/fenetre-pvc" },
    { label: "Fenêtre Alu", href: "/fenetre-alu" },
    { label: "Fenêtre Bois", href: "/fenetre-bois" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur les pièces PVC.",
  imageAlt: "[PHOTO technicien réparant une fenêtre PVC]",
  imageSrc: IMG_PVC_SERVICE,
};

// =========================================================
// ALU
// =========================================================
export const aluPieces: PiecesProps = {
  ...defaultPieces,
  title: "Pièces pour fenêtre aluminium : remplacement sur place",
  description:
    "Fenêtre aluminium qui force, bloque ou perd en étanchéité ? Notre technicien arrive avec un stock de ferrures adaptées aux profilés fins et vantaux larges de l'aluminium. Pas besoin de commander en ligne.",
  items: [
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Ferrures aluminium comprises, marques GU, Roto, Siegenia, Winkhaus.",
  imageAlt: "[PHOTO ferrures de fenêtre aluminium et profilé métal]",
  imageSrc: IMG_ALU,
};

export const aluServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de fenêtre aluminium : nos interventions à domicile",
  description:
    "DF PRO Strasbourg répare les fenêtres aluminium : ferrures, serrage, étanchéité. Intervention rapide, pièces comprises, diagnostic gratuit. Votre fenêtre aluminium moderne retrouve son fonctionnement.",
  items: [
    { label: "Fenêtre Alu", href: "/fenetre-alu" },
    { label: "Fenêtre PVC", href: "/fenetre-pvc" },
    { label: "Fenêtre Bois", href: "/fenetre-bois" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur les ferrures aluminium.",
  imageAlt: "[PHOTO technicien réparant une fenêtre aluminium]",
  imageSrc: IMG_ALU_SERVICE,
};

// =========================================================
// BOIS
// =========================================================
export const boisPieces: PiecesProps = {
  ...defaultPieces,
  title: "Pièces pour fenêtre bois : remplacement sur place",
  description:
    "Fenêtre en bois qui gonfle, ferme mal ou mécanisme ancien usé ? Notre technicien arrive avec un stock de pièces robustes adaptées au poids et aux mouvements du bois. Pas besoin de commander en ligne.",
  items: [
    { label: "Crémone et crémaillère", href: "/cremone-fenetre" },
    { label: "Renvoi d'angle et croisillon", href: "/cremone-fenetre" },
    { label: "Poignée de fenêtre", href: "/poignee-fenetre-bloquee" },
    { label: "Gâche et tétière", href: "/cremone-fenetre" },
    { label: "Gonds et paumelles", href: "/gond-paumelle-fenetre" },
    { label: "Joints de frappe et d'étanchéité", href: "/fenetre-ferme-mal" },
    { label: "Mécanisme oscillo-battant", href: "/fenetre-oscillo-battant-bloquee" },
  ],
  highlight: "Pièces bois comprises, toutes marques et spécificités du bois.",
  imageAlt: "[PHOTO ferrures de fenêtre en bois et charnières traditionnelles]",
  imageSrc: IMG_BOIS,
};

export const boisServices: ServicesProps = {
  ...defaultServices,
  title: "Réparation de fenêtre bois : nos interventions à domicile",
  description:
    "DF PRO Strasbourg répare les fenêtres en bois : mécanisme, gonds, serrage. Intervention rapide, pièces robustes comprises, diagnostic gratuit. Vous gardez le charme et la durabilité de votre fenêtre en bois.",
  items: [
    { label: "Fenêtre Bois", href: "/fenetre-bois" },
    { label: "Fenêtre PVC", href: "/fenetre-pvc" },
    { label: "Fenêtre Alu", href: "/fenetre-alu" },
    { label: "Réglage d'oscillo-battant", href: "/reglage-fenetre-oscillo-battant" },
    { label: "Déblocage de fenêtre bloquée", href: "/fenetre-oscillo-battant-bloquee" },
    { label: "Remplacement de crémone", href: "/cremone-fenetre" },
    { label: "Remplacement de poignée", href: "/poignee-fenetre-bloquee" },
  ],
  highlight: "Diagnostic et déplacement gratuits, garantie 10 ans sur les pièces bois.",
  imageAlt: "[PHOTO technicien réparant une fenêtre en bois traditionnelle]",
  imageSrc: IMG_BOIS_SERVICE,
};

// =========================================================
// VILLES — helper
// =========================================================
export function getVillePieces(ville: string): PiecesProps {
  return {
    ...defaultPieces,
    title: `Toutes les pièces de votre fenêtre, réparées chez vous à ${ville}`,
    description: `Quel que soit le type de fenêtre ou la marque de vos ferrures, notre technicien intervient à ${ville} et dans les environs avec un stock de pièces de rechange adaptées. Pas besoin de commander en ligne ni d'attendre des semaines.`,
    imageAlt: `[PHOTO pièces de fenêtre : crémone, poignée, gonds — réparation à ${ville}]`,
    imageSrc: IMG_DEFAULT_PIECES,
  };
}

export function getVilleServices(ville: string): ServicesProps {
  return {
    ...defaultServices,
    title: `Réparer plutôt que remplacer : nos interventions à ${ville}`,
    description: `DF PRO Strasbourg répare toutes les pannes courantes de fenêtre à ${ville} et dans les communes voisines. Intervention rapide, pièces comprises, toutes marques. Un diagnostic précis avant chaque travail.`,
    imageAlt: `[PHOTO technicien réparant une fenêtre à ${ville}]`,
    imageSrc: IMG_DEFAULT_SERVICES,
  };
}